// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <missing-access-warning
    missing-access="CST_DEPOSIT_ACCOUNT_READ">
  </missing-access-warning>

  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Deposit number:</span>
      <span class="value">{{\$ctrl.termDeposit.productNumber}}
        </span>
    </div>
  </div>

  <h2 class="section-header">Update term deposit signature card</h2>

  <form name="\$ctrl.form">
    <file-upload
      ng-model="\$ctrl.signatureCardFiles"
      validate-uploaded
      name="documentUpload"
      enable-webcam="false"
      show-remarks="true"
      show-file-name="true"
      max-files="1"
      allow-duplicates="false"
    ></file-upload>

    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        ng-click="\$ctrl.update()"
        ng-disabled="\$ctrl.form.\$invalid">
        Update
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/edit-term-deposit-signature-card/edit-term-deposit-signature-card.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;